import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3cc70dd4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body mb-10" }
const _hoisted_3 = {
  key: 0,
  class: "card-title"
}
const _hoisted_4 = {
  key: 1,
  class: "fw-lighter"
}
const _hoisted_5 = { class: "row mt-10" }
const _hoisted_6 = { class: "col-md-3" }
const _hoisted_7 = {
  key: 0,
  class: "d-flex justify-content-center mt-15 mb-15"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border spinner-lg",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "list-group list-group-numbered" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "ms-2 me-auto" }
const _hoisted_13 = { class: "fw-bold" }
const _hoisted_14 = { class: "col-md-9 d-flex" }
const _hoisted_15 = {
  key: 0,
  class: "d-flex justify-content-center mt-15 mb-15",
  style: {"width":"100%"}
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border spinner-lg",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("video", {
  controls: "",
  crossorigin: "",
  playsinline: ""
}, [
  /*#__PURE__*/_createElementVNode("source", {
    size: "1080",
    type: "video/mp4"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_vue_plyr = _resolveComponent("vue-plyr")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.course)
        ? (_openBlock(), _createElementBlock("h2", _hoisted_3, _toDisplayString(_ctx.course.title), 1))
        : _createCommentVNode("", true),
      (_ctx.course)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.course.description), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            _createElementVNode("ol", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.videoList, (video) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: video.streaming,
                  class: _normalizeClass(["custom-style list-group-item d-flex justify-content-between align-items-start list-group-item-action", 
                    video.streaming === _ctx.selectedVideo?.streaming ? 'active' : ''
                  ]),
                  onClick: () => _ctx.selectVideo(video.streaming)
                }, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, _toDisplayString(video.title), 1),
                    _createTextVNode(" " + _toDisplayString(video.description), 1)
                  ])
                ], 10, _hoisted_11))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_el_divider, { direction: "vertical" }),
          (!_ctx.showPlyr)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            style: _normalizeStyle([!_ctx.showPlyr ? 'display: none' : '', {"width":"100%"}]),
            class: "ms-3"
          }, [
            _createVNode(_component_vue_plyr, {
              ref: "plyr",
              options: _ctx.options
            }, {
              default: _withCtx(() => [
                _hoisted_18
              ]),
              _: 1
            }, 8, ["options"])
          ], 4)
        ])
      ])
    ])
  ]))
}